import { useEffect } from "react";
import DashboardLayout from "../../../../src/layoutcontainers/DashboardLayout/index";
import {
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../src/components/MaterialBox";
import { useState } from "react";
import MaterialButton from "../../../../src/components/MaterialButton";
import ConfirmationDialog from "../../../../src/components/Dialog/ConfirmationDialog";
import EditIcon from "@mui/icons-material/Edit";
import BASEURL from "../../../../src/pages/Utils/Baseurl";
import axios from "axios";
import MaterialTypography from "../../../components/MaterialTypography";
import Swal from "sweetalert2";
import { Autocomplete, TextField } from "@mui/material";
import { useUserDetails } from "../../../context/auth";
import { useLoading } from "../../../context/loading";
const AddWeekOff = () => {
  const { AccessData } = useUserDetails();
  const [id, setId] = useState("");
  const { setCirleLoading } = useLoading();
  const weekoffOptions = [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ];

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [weekoffData, setWeekoffData] = useState({
    weekoffDays: [],
    weekoffDaysStatus: "unchecked",
  });

  const [originalWeekoffData, setOriginalWeekoffData] = useState({
    weekoffDays: [],
  });

  useEffect(() => {
    fetchWeekoffData();

    if (id) {
      getInitData(id);
    }
  }, [id]);

  const fetchWeekoffData = async () => {
    setCirleLoading(true);
    const query = `
      query GetAllWeekoff {
        allWeekoffConfigurations {
          id
          weekoffDays
          lastUpdate
        }
      }
    `;

    try {
      const response = await axios.post(
        BASEURL,
        { query },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const weekoffList = response.data?.data?.allWeekoffConfigurations || [];

      if (weekoffList.length === 1) {
        setId(weekoffList[0].id);
      }
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState((prev) => ({
        ...prev,
        loading: false,
        error: true,
        message: error.message,
      }));
    } finally {
      setCirleLoading(false);
    }
  };
  const onWeekoffSubmit = async () => {
    setCirleLoading(true);
    const query = `
           mutation CreateWeekoff($input: WeekoffConfigurationInput!) { 
    createWeekoffConfiguration(input: $input) { 
    success 
    message 
    weekoff { 
    id 
   weekoffDays 
   lastUpdate 
   }
 } 
} 
`;

    const formattedWeekoffDays = weekoffData.weekoffDays.join(",");

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              weekoffDays: formattedWeekoffDays,
            },
          },
        }),
      });

      let result = response.data.data.createWeekoffConfiguration;
      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WeekOff Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }
      fetchWeekoffData();
      setTogglePage({
        view: true,
        edit: false,
      });
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for the inconvenience. There was a network issue. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const onEditWeekoffSubmit = async () => {
    setCirleLoading(true);
    const query = `
        mutation UpdateWeekoff($id: ID!, $input: WeekoffConfigurationInput!) { 

  updateWeekoffConfiguration(id: $id, input: $input) { 

    success 

    message 

    weekoff { 

      id 

      weekoffDays 

      lastUpdate 

    } 

  } 

} 
        `;
    const formattedWeekoffDays = weekoffData.weekoffDays.join(",");
    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            input: {
              weekoffDays: formattedWeekoffDays,
            },
          },
        }),
      });

      let result = response.data.data.updateWeekoffConfiguration.success;

      if (result !== "") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "WeekOff Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      if (response.data.errors) {
        throw new Error(response.data.errors[0].message);
      }
      fetchWeekoffData();
      setTogglePage({
        view: true,
        edit: false,
      });
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });

      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const getInitData = async (id) => {
    setCirleLoading(true);
    const query = `query GetWeekoffById($id: ID!) { 

  weekoffConfigurationById(id: $id) { 

    id 

    weekoffDays 

    lastUpdate 

  } 

}  `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const weekoffRowdata = response.data.data.weekoffConfigurationById;

      let weekoffdays = weekoffRowdata.weekoffDays.split(",") || [];

      setWeekoffData({
        weekoffDays: weekoffdays,
        weekoffDaysStatus: "success",
      });

      setOriginalWeekoffData({
        weekoffDays: weekoffdays,
      });
      setTogglePage({
        view: true,
        edit: false,
      });
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    } finally {
      setCirleLoading(false);
    }
  };

  const handleweekoofchange = (event, selectEvent) => {
    let weekoffState = { ...weekoffData };
    const selectedDays = event;
    weekoffState["weekoffDaysStatus"] =
      selectedDays.length > 0 ? "success" : "unchecked";
    weekoffState["weekoffDays"] = selectedDays.map((day) => day.value);
    setWeekoffData(weekoffState);
  };

  const handleAddWeekOff = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onWeekoffSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardWeekoff = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setWeekoffData({
      weekoffDaysStatus: "success",
      weekoffDays: originalWeekoffData.weekoffDays,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (weekoffData.weekoffDaysStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Weekoff Details
                    </MaterialTypography>
                  </Stack>
                  {/* {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditWeekOff" && item.can_access
                      ) &&
                      pageState.state !== "submitting" && ( */}
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                  </ButtonGroup>
                  {/* )} */}
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add WeekOff
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent
          sx={{
            minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
          }}
        >
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    WeekOff <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>

                {/* <Autocomplete
                  multiple
                  options={weekoffOptions}
                  value={weekoffData.weekoffDays.map((day) => ({
                    value: day,
                    label: day,
                  }))}
                  
                  onChange={(event, newValue) =>
                    handleweekoofchange(newValue, { name: "weekoffDays" })
                  }
                  
                  disabled={togglePage.view === true ? true : false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Choose multiple days"
                    />
                  )}
                /> */}
                <Autocomplete
                  multiple
                  options={weekoffOptions.filter(
                    (option) => !weekoffData.weekoffDays.includes(option.value) // 👈 custom filter
                  )}
                  value={weekoffData.weekoffDays.map((day) => ({
                    value: day,
                    label: day,
                  }))}
                  onChange={(event, newValue) =>
                    handleweekoofchange(newValue, { name: "weekoffDays" })
                  }
                  getOptionLabel={(option) => option.label}
                  disabled={togglePage.view === true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Choose multiple days"
                    />
                  )}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>

        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage.edit === true ? (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                disabled={pageState.state === "submitting"}
                onClick={onDiscardWeekoff}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={onEditWeekoffSubmit}
              >
                Update
              </MaterialButton>
            </>
          ) : togglePage.view === false && togglePage.edit === false ? (
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddWeekOff}
            >
              Submit
            </MaterialButton>
          ) : null}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default AddWeekOff;
